/** Approbation status — Docia only. */
export enum ApprobationStatus {
  GermanApprobation = 'german_approbation',
  ProfessionalLicense = 'professional_license',
  InRecognition = 'in_recognition',
  None = 'none',
}

export const APPROBATION_STATUS_I18N: Record<ApprobationStatus, string> = {
  [ApprobationStatus.GermanApprobation]: 'Approbation erteilt (DE)',
  [ApprobationStatus.ProfessionalLicense]: 'Berufserlaubnis (§ 10 BÄO)',
  [ApprobationStatus.InRecognition]: 'Im Anerkennungsverfahren',
  [ApprobationStatus.None]: 'Noch kein Antrag',
};
